export function checkForDisbursementDates(incoming) {
  const found = incoming.find((obj) => obj.disbursementDate);

  if (found) {
    return "Est. Disbursement";
  } else {
    return "Term";
  }
}
